var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10398",
    "data-name": "Group 10398",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.25,
    height: 20,
    viewBox: "0 0 20.25 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3041",
    "data-name": "Rectangle 3041",
    width: 11.997,
    height: 13.284,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10159",
    "data-name": "Group 10159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10055",
    "data-name": "Group 10055"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2970",
    "data-name": "Rectangle 2970",
    width: 20.25,
    height: 20,
    rx: 10,
    fill: "#4a90f7"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10160",
    "data-name": "Group 10160",
    transform: "translate(4.942 2.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10159-2",
    "data-name": "Group 10159",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3240",
    "data-name": "Path 3240",
    d: "M9.166,13.284H0V1.36H.186q1.879,0,3.759,0a.379.379,0,0,0,.275-.1A4.452,4.452,0,0,1,8.768.241,4.421,4.421,0,0,1,11.9,3.751,4.58,4.58,0,0,1,9.337,8.817a.259.259,0,0,0-.175.28c.006,1.324,0,2.648,0,3.972Zm-1.8-4.946a3.7,3.7,0,1,0-3.7-3.691,3.7,3.7,0,0,0,3.7,3.691m-6.458,4h7.3V9.2c-.064.006-.119.008-.172.016a4.588,4.588,0,0,1-2.758-.441.744.744,0,0,0-.31-.075c-.833-.006-1.666,0-2.5,0H2.287V7.761H3.934a5.253,5.253,0,0,1-.447-.625.465.465,0,0,0-.528-.282,6.472,6.472,0,0,1-.675,0V5.936h.641a4.666,4.666,0,0,1,.453-3.649H.913Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3241",
    "data-name": "Path 3241",
    d: "M15.6,6.635l.629.637-3.338,3.34L10.722,8.44l.627-.622L12.889,9.35,15.6,6.635",
    transform: "translate(-6.222 -3.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3040",
    "data-name": "Rectangle 3040",
    width: 4.566,
    height: 0.907,
    transform: "translate(2.281 9.615)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpApprove);
export default __webpack_public_path__ + "static/media/op-approve.23e270f91ff556b95a0ff1fc62b2a02a.svg";
export { ForwardRef as ReactComponent };